module.exports = __webpack_public_path__ + "media/components/maps/incidents/pins/Violent Crime-1e7b47a4cb8c5e802e89ca748026ee3f.png";